import { isFuture } from 'date-fns';
import localization from '../localization';
import { isEditMode } from '../utils';

export default {
  moveInDate: {
    isValid: (date) => isEditMode() ? true : isFuture(date),
    message: (lang) => localization[lang].movein_errors.movein_date
  }
};
